import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'
import LIFromFiltrosCliente from './Components/LIFromFiltrosCliente'
import './styles/lista-cliente.css'
import TableListCliente from './Components/TableListCliente'
import ModalsControlsCliente from './modals/ModalsControlsCliente'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGCListarClientes} from '../../../actions/action-creators'
import {gc_lc_Clear} from '../../../actions/gestion-cliente/lista-cliente/listaCliente.actions'

const ListaCliente = () => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGCListarClientes, dispatch)

  useEffect(() => {
    window.scroll(0, 0)
    actions.gc_lc_GetClientes()
    return () => {
      dispatch(gc_lc_Clear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BasicLayout>
      <ModalsControlsCliente />
      <div className='header'>
        <Link to='/gestion-clientes' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Lista de Clientes</h3>
      </div>
      <div className='separador'></div>
      <LIFromFiltrosCliente />
      <TableListCliente />
    </BasicLayout>
  )
}

export default ListaCliente
